import { render } from "./index.vue?vue&type=template&id=08695edc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=08695edc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\11710\\Desktop\\admin-box-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08695edc"]])

export default __exports__